export const resultPerPage = 15;